import { useMutation, useQuery } from "@tanstack/react-query";
import { HouseAPI } from "../houseApi";

export const getHouseQueryKey = (id?: string) => ["house", id];

export const useGetHouse = (id?: string) => {
  return useQuery(getHouseQueryKey(id), () => HouseAPI.getHouse(id!), {
    enabled: Boolean(id)
  });
};

const getHousesQueryKey = (id?: string) => ["house", id];

export const useGetHouses = (id?: string) => {
  return useQuery(
    getHousesQueryKey(id),
    () => {
      if (!id) {
        return;
      }
      return HouseAPI.getHouses(id);
    },
    {
      enabled: Boolean(id)
    }
  );
};

export const useChangeLiked = () => {
  return useMutation<
    unknown,
    unknown,
    { isLiked: boolean; studentId: string; hostId: string; houseId: string }
  >({
    mutationFn: (payload) =>
      HouseAPI.changeLiked(
        payload.isLiked,
        payload.studentId,
        payload.hostId,
        payload.houseId
      )
  });
};
